import React from 'react';
import { StepsIntl } from './Steps.intl';
import './Steps.scss';
import { useIntl } from 'react-intl';
import { CheckRounded } from '@material-ui/icons';
import { useQueryClient } from 'react-query';
import { QueryKey, useAdasImages, useImageUrl, steps, closeAppDialog } from '../helper';
import { useParams } from 'react-router';
import { UrlParams } from '../models';
import { InfoScreen } from '../InfoScreen';
import { CalibrationIntl } from '../Calibration.intl';
import { useBem } from '../../Bem';

export const Step1 = () => {
  const queryClient = useQueryClient();
  const { url: data } = useImageUrl();
  const bem = useBem('step1');
  const intl = useIntl();
  const { deviceImei } = useParams<UrlParams>();
  const { adasImages, isErrorAdas } = useAdasImages(deviceImei);

  if (isErrorAdas) {
    return (
      <InfoScreen
        type={intl.formatMessage(CalibrationIntl.error)}
        message={intl.formatMessage(CalibrationIntl.errorImageMessage)}
        action={{
          title: intl.formatMessage(CalibrationIntl.close),
          method: () => closeAppDialog(),
        }}
      />
    );
  }
  const imagesFromBE = Object.assign(adasImages?.images.map((url: string, id: string | number) => ({ id, url })));
  return (
    <div>
      <p className={bem.elem('title').cls()}>
        <span>(1/{steps.length})&nbsp;</span>
        <span>{intl.formatMessage(StepsIntl.titleStep_1)}</span>
      </p>
      <div className={bem.elem('img-container').cls()}>
        {imagesFromBE.map(({ id, url }: { id: number; url: string }) => (
          <div
            key={id}
            className={bem.elem('img').cls()}
            onClick={() => {
              queryClient.setQueryData(QueryKey.imageUrl, { id, url });
            }}
          >
            <img src={url} />
            <div
              className={bem
                .elem('img-overlay')
                .mods(id === data?.id && 'active')
                .cls()}
            >
              <div
                className={bem
                  .elem('img-circle')
                  .mods(id === data?.id && 'active')
                  .cls()}
              >
                <CheckRounded
                  className={bem
                    .elem('circle-checked')
                    .mods(id === data?.id && 'active')
                    .cls()}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
